// API base URL: usa localhost en desarrollo, relativo (mismo host) en producción.
// En prod resuelve a https://matcher.pulpouplatform.com o https://tia.pulpouplatform.com
// (ambos apuntan a price 37.27.2.126, nginx :443 → Express :3101).
export const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3101'
  : '';

// FUNCTIONS_DIRECT_URL removed 2026-06-08: backend unificado en price, ya no se usa Cloud Functions.
// Rollback a Firebase Hosting + Cloud Functions: ver `docs/tia-ecuador/ROLLBACK_FIREBASE_2026-06-08.md`.
